import { useState, useEffect, useRef } from "react";
import { motion } from "motion/react";

export default function Testimonial(){
    // const testimonial = [
    //     {
    //       test:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vestibulum vehicula elementum. Quisque quis dictum ipsum. Donec pretium convallis ante, non semper elit feugiat non. Lorem ipsum dolorpellentesque facilisis.",
    //       name:"Khalid Al Dawsry",
    //       loc:"Jeddah, Saudi",
    //       pic:"../images/client.jpg"
    //     },{
    //       test:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vestibulum vehicula elementum. Quisque quis dictum ipsum. Donec pretium convallis ante, non semper elit feugiat non. Lorem ipsum dolorpellentesque facilisis.",
    //       name:"2Khalid Al Dawsry",
    //       loc:"Jeddah, Saudi",
    //       pic:"../images/client.jpg"
    //     },{
    //       test:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vestibulum vehicula elementum. Quisque quis dictum ipsum. Donec pretium convallis ante, non semper elit feugiat non. Lorem ipsum dolorpellentesque facilisis.",
    //       name:"3Khalid Al Dawsry",
    //       loc:"Jeddah, Saudi",
    //       pic:"../images/client.jpg"
    //     },{
    //       test:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vestibulum vehicula elementum. Quisque quis dictum ipsum. Donec pretium convallis ante, non semper elit feugiat non. Lorem ipsum dolorpellentesque facilisis.",
    //       name:"4Khalid Al Dawsry",
    //       loc:"Jeddah, Saudi",
    //       pic:"../images/client.jpg"
    //     },{
    //       test:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vestibulum vehicula elementum. Quisque quis dictum ipsum. Donec pretium convallis ante, non semper elit feugiat non. Lorem ipsum dolorpellentesque facilisis.",
    //       name:"5Khalid Al Dawsry",
    //       loc:"Jeddah, Saudi",
    //       pic:"../images/client.jpg"
    //     }
    //   ]

    const testimonial = [
        {
          test:"Selling my old gold jewelry at Aurum Gold Company was a very smooth process. I received instant cash payments, and the valuation they provided was fair and transparent. Excellent service!",
          name:"Mohan Kumar",
          loc:"Katpadi, Vellore",
          pic:"../images/client.jpg"
        },{
          test:"I had pledged my gold jewelry, and Aurum Gold Company helped me release it quickly. They provided the promised funds on time and were very trustworthy throughout the process. Thank you, Aurum Gold!",
          name:"Revathi Parameswaran",
          loc:"Sathuvachari, Vellore",
          pic:"../images/client.jpg"
        },{
          test:"If you want to sell gold, this is the best place to get a precise valuation. I received the payment on the spot and with no hassle. Highly recommend their services!",
          name:"Santosh Venkatesh",
          loc:"Ambur, Tirupattur",
          pic:"../images/client.jpg"
        },{
          test:"The experience of selling gold at Aurum Gold Company was seamless. Their approach is honest, trustworthy, and efficient. I strongly recommend this company for anyone in the region looking for reliable gold services.",
          name:"Lalitha Naresh",
          loc:" Arani, Tiruvannamalai",
          pic:"../images/client.jpg"
        },{
          test:"I had been searching for a good place to sell gold, and Aurum Gold Company provided the best experience. They were quick, reliable, and offered a great price. I’ll definitely return in the future!",
          name:"Prasad Rajan",
          loc:"Gudiyatham , Vellore",
          pic:"../images/client.jpg"
        },{
          test:"I was unsure about where to sell my gold until a friend recommended Aurum Gold Company. Every transaction was clear and fair, and I am extremely satisfied with their service!",
          name:"Anita Hariharan",
          loc:"Vaniyambadi, Vellore",
          pic:"../images/client.jpg"
        },
    ]
  
      const [testIndex, setTestIndex] = useState(0)
      useEffect(()=>{
        const testimonialMove = setInterval(()=>{
          if(testIndex<testimonial.length-1){
            setTestIndex(testIndex+1)
          }else{
            setTestIndex(0)
          }
        }, 10000)
        return ()=>clearInterval(testimonialMove)
      },[testIndex, testimonial.length])
      
      const scrollRefTest = useRef(null)

      return(
        <section className="container testimonialContainer">
            <div ref={scrollRefTest} style={{width:"100%"}}>
            <motion.main
                initial={{ opacity: 0, translateY:100, }}
                whileInView={{ opacity: 1,translateY:0  }}
                viewport={{ root: scrollRefTest, once:true }}
                transition={{duration:.5, delay:0.25}}
              >
              <article>
                <div className="testSlider" style={{width:`calc(${testimonial.length} * var(--side))`, transform:`translateX(calc( ${testIndex * -1} * var(--side)))`}}>
                  {/* <div className="testSlide">
                    <p className="test">
                      <span>"</span>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vestibulum vehicula elementum. Quisque quis dictum ipsum. Donec pretium convallis ante, non semper elit feugiat non. Lorem ipsum dolorpellentesque facilisis.
                    </p>
                    <aside>
                      <p className="client">
                        Khalid Al Dawsry<br/>
                        <span>Jeddah, Saudi</span>
                      </p>
                      <figure className="clientPic">
                        <img src="../images/client.jpg" alt="client"/>
                      </figure>
                    </aside>
                  </div> */}

                  {testimonial.map((test,key)=>(
                    <div className="testSlide" key={key}>
                      <p className="test">
                        <span>“</span>
                        {test.test}
                      </p>
                      <aside>
                        <p className="client">
                          {test.name}<br/>
                          <span>{test.loc}</span>
                        </p>
                        <figure className="clientPic">
                          <img src={test.pic} alt="client"/>
                        </figure>
                      </aside>
                    </div>
                  ))}
                  
                </div>
                <div className="testBar">
                  <div style={{width:`${100/testimonial.length}%`,left:`${(100/testimonial.length)*testIndex}%`}}/>
                </div>
                <figure className="decorTest">
                  <img src="../images/testDecor.svg" alt="decor"/>
                </figure>
              </article>
              <figure className="testimonialJewell">
                <img src="../images/jewell_2.png" alt="jewell_2"/>
              </figure>
            </motion.main>
            </div>
        </section>
      )
}